export const inputFieldTypes = ['INPUT'];
export const selectFieldTypes = ['PAYMENT_METHOD', 'RADIO', 'SELECT'];
